module.exports = __webpack_public_path__ + "static/media/CTLI_6-178w.38d87aae.webp";